var _defs, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuppy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5c0 .861-.439 1.613-1.103 2.062C15.67 6.272 16 8.228 16 10c0 4.418-3.582 6-8 6s-8-1.582-8-6c0-1.772.33-3.728 1.103-5.438A2.482 2.482 0 010 2.5 2.5 2.5 0 012.5 0c.751 0 1.41.343 1.866.869C5.37.325 6.567 0 8 0c1.432 0 2.629.325 3.632.868A2.462 2.462 0 0113.5 0 2.5 2.5 0 0116 2.5zM8 15c4.645 0 7-1.683 7-5 0-4.151-1.833-9-7-9s-7 4.849-7 9c0 3.317 2.355 5 7 5zM3.5 9C3.224 9 3 8.553 3 8c0-.553.224-1 .5-1s.5.447.5 1c0 .553-.224 1-.5 1zm9 0c-.276 0-.5-.447-.5-1 0-.553.224-1 .5-1s.5.447.5 1c0 .553-.224 1-.5 1zM11 10.5a.5.5 0 01.5.5 2 2 0 01-2 2 1.991 1.991 0 01-1.5-.689A1.991 1.991 0 016.5 13a2 2 0 01-2-2 .5.5 0 011 0 1 1 0 102 0c0-.016.007-.028.009-.043C6.681 10.824 6 10.352 6 9.5 6 8.483 6.966 8 8 8s2 .483 2 1.5c0 .852-.681 1.324-1.509 1.457.002.015.009.027.009.043a1 1 0 102 0 .5.5 0 01.5-.5zm-4-1c0 .276.448.5 1 .5s1-.224 1-.5S8.552 9 8 9s-1 .224-1 .5zm-6-7c0 .473.23.879.572 1.152.506-.862 1.141-1.634 1.94-2.24A1.468 1.468 0 002.5 1 1.5 1.5 0 001 2.5zM13.5 1c-.395 0-.745.162-1.011.413.799.606 1.434 1.378 1.939 2.239.341-.274.572-.68.572-1.152A1.5 1.5 0 0013.5 1z",
    id: "puppy_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "puppy_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#puppy_svg__a"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: props.color,
    xlinkHref: "#puppy_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#puppy_svg__b)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v15.964H0z"
  })))));
}
export default SvgPuppy;